export default {
  1: {
    label: 'Name',
    nested: [
      {
        type: 'text',
        name: 'firstname',
        placeholder: 'First Name',
        validation: {
          required: true,
        },
        icon: 'user',
      },
      {
        type: 'text',
        name: 'middlename',
        placeholder: 'Middle Name',
        validation: {},
        icon: 'user',
      },
      {
        type: 'text',
        name: 'lastname',
        placeholder: 'Last Name',
        validation: {
          required: true,
        },
        icon: 'user',
      },
      {
        type: 'text',
        name: 'suffix',
        placeholder: 'Suffix',
        validation: {},
        icon: 'user',
      },
    ],
  },
  2: {
    type: 'text',
    name: 'license',
    validation: {
      required: true,
    },
    label: 'License Number',
    placeholder: 'Your license number',
    icon: 'gavel',
  },
  3: {
    type: 'email',
    name: 'email',
    validation: {
      required: true,
    },
    label: 'Email',
    placeholder: 'Your email',
    icon: 'envelope',
  },
  4: {
    type: 'text',
    name: 'firm',
    validation: {
      required: true,
    },
    label: 'Name of Your Firm',
    placeholder: 'Your firm\'s name',
    icon: 'building',
  },
  5: {
    type: 'tel',
    name: 'phone',
    validation: {
      required: true,
    },
    label: 'Phone number',
    placeholder: 'Your phone number',
    icon: 'phone',
  },
};
